import {
  HONEST_JOBS_WIDGET_TYPE,
  isHonestJobsApiWidgetType,
  mapHonestJobsWidgetProps,
  widgetTypeRequiresReentryPlan,
} from './honest-jobs-widget.util';

export const UNKNOWN_WIDGET_TYPE = 'unknown';

const WIDGET_MAPPERS = [
  {
    matches: isHonestJobsApiWidgetType,
    type: HONEST_JOBS_WIDGET_TYPE,
    mapProps: mapHonestJobsWidgetProps,
  },
];

const resolveWidgetMapper = (apiWidgetType) =>
  WIDGET_MAPPERS.find((entry) => entry.matches(apiWidgetType)) ?? null;

export const mapWidget = (widget, reentryPlanItems = {}) => {
  const apiWidgetType = widget?.widgetType ?? '';
  const mapper = resolveWidgetMapper(apiWidgetType);

  if (!mapper) {
    return { type: UNKNOWN_WIDGET_TYPE, props: {} };
  }

  return {
    type: mapper.type,
    props: mapper.mapProps(widget, reentryPlanItems),
  };
};

export const requiresReentryPlanFetch = (sections = []) =>
  sections.some((section) =>
    (section.widgets ?? []).some((widget) =>
      widgetTypeRequiresReentryPlan(widget?.widgetType ?? ''),
    ),
  );
